// @flow

import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
  Grid,
  Col,
  MEDIA,
  COLORS,
  FONT_WEIGHT,
  TYPE_SCALE,
  SPACING,
  LINE_HEIGHT,
} from 'clark-styles';

import Location from 'assets/icons/location.svg';
import Subject from 'assets/icons/subject.svg';

const { CLARK_PRIMARY, CLARK_SECONDARY, GREY_100, GREY_75 } = COLORS;
const { S_05, S_1, S_2, S_4 } = SPACING;
const { FW_100, FW_400 } = FONT_WEIGHT;
const { TS_3 } = TYPE_SCALE;
const { TITLE } = LINE_HEIGHT;

export const GridWrapper = styled<any>(Grid)`
  margin-top: ${S_2};

  ${MEDIA.medium`
    margin-top: ${S_4};
  `};
`;

export const ActionsCol = styled<any>(Col)`
  margin-top: ${S_2};

  ${MEDIA.medium`
    margin-top: 0;
  `};
`;

export const Header = styled.h1`
  ${FW_400};
  ${TS_3};
  ${TITLE};
  color: ${GREY_100};
  margin: 0 0 ${S_1} 0;
`;

export const StyledLink = styled<any>(Link)`
  ${FW_100};
  color: ${CLARK_PRIMARY};
  display: block;
  margin-bottom: ${S_2};
  text-decoration: none;
`;

export const InfoItem = styled.div`
  ${FW_100};
  align-items: center;
  display: flex;
  color: ${GREY_75};
  margin-bottom: ${S_05};
`;

// $FlowFixMe
export const SubjectIcon = styled<any>(Subject)`
  color: ${CLARK_SECONDARY};
`;

// $FlowFixMe
export const LocationIcon = styled<any>(Location)`
  color: ${CLARK_SECONDARY};
`;

export const InfoCopy = styled.span`
  ${FW_400};
  margin: 0 ${S_05};
`;

export const DataWrapper = styled.div`
  width: 50%;
`;



// WEBPACK FOOTER //
// ./src/components/sessions/view/header/styles.js